// extracted by mini-css-extract-plugin
export default {"bottom_affix":"index_bottom_affix_5CCxq","backToTop":"index_backToTop_jGxWP"};